import { createFileRoute } from "@tanstack/react-router"

import LegalPage from "@/features/static/components/legal"

export const Route = createFileRoute("/_screen/legal")({
  component: Legal
})

function Legal() {
  return <LegalPage />
}
